import axios from 'axios';

import { handleApiError } from '../../../../shared/core/helpers/ApiErrorHelper';
import { PartnersContentApiResponse } from '../api-model/PartnersContentApiModel';
import {
  getPartnersCMSUrl,
  getPartnerVehiclesRequestUrl,
  getSubmitVehicleFormUrlAndPayload,
} from '../data-source/PartnersDataSource';
import { PartnersContentEntity } from '../entities/PartnersContentEntity';
import { parseFormResponse } from '../entity-mapper/PartnerFormResponseEntityMapper';
import { apiModelToEntity } from '../entity-mapper/PartnersContentEntityMapper';
import { parseVehicleTypes } from '../entity-mapper/PartnerVehicleTypesEntityMapper';

import { AttachVehicleFormModel } from './types/AttachVehicleFormModel';
import { AttachVehicleFormResponseModel } from './types/AttachVehicleFormResponseModel';
import { PartnerVehicle } from './types/PartnerVehicle';

export async function getMainPageContent(
  locale: string,
): Promise<PartnersContentEntity> {
  const countryCode = locale.split('-').pop() ?? '';
  const requestUrl = getPartnersCMSUrl(countryCode, locale);

  try {
    const response = await axios.get<PartnersContentApiResponse>(requestUrl);
    return apiModelToEntity(response.data);
  } catch (error: unknown) {
    handleApiError(error, 'PartnersRepo.getMainPageContent');
    throw error;
  }
}

export async function fetchPartnerVehicles(
  geoRegionId: number,
): Promise<PartnerVehicle[]> {
  const requestUrl = getPartnerVehiclesRequestUrl(geoRegionId);

  try {
    const response = await axios.get(requestUrl, {
      headers: { 'Content-Type': 'application/json', 'Accept': '*/*' },
    });
    return parseVehicleTypes(response.data);
  } catch (error: unknown) {
    handleApiError(error, 'PartnersRepo.fetchPartnerVehicles');
    throw error;
  }
}

export async function submitAttachVehicleForm(
  form: AttachVehicleFormModel,
): Promise<AttachVehicleFormResponseModel> {
  const { url, payload } = getSubmitVehicleFormUrlAndPayload(form);

  try {
    const response = await axios.post(url, JSON.parse(payload), {
      headers: { 'Content-Type': 'application/json', 'Accept': '*/*' },
    });
    return parseFormResponse(response.data);
  } catch (error: unknown) {
    handleApiError(error, 'PartnersRepo.submitAttachVehicleForm');
    throw error;
  }
}
